import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { WorkOrderExecutionResult } from '@evimo/types/enums/maintenance-execution';

export function useWorkOrderCompleteExecutionResultOptions() {
  const { t } = useTranslation('maintenance');

  return useMemo(
    () => [
      {
        value: WorkOrderExecutionResult.COMPLETED_OK,
        label: t('workOrders.executionResult.COMPLETED_OK'),
      },
      {
        value: WorkOrderExecutionResult.COMPLETED_WITH_ISSUE,
        label: t('workOrders.executionResult.COMPLETED_WITH_ISSUE'),
      },
      {
        value: WorkOrderExecutionResult.NOT_DONE,
        label: t('workOrders.executionResult.NOT_DONE'),
      },
      {
        value: WorkOrderExecutionResult.CANCELLED,
        label: t('workOrders.executionResult.CANCELLED'),
      },
    ],
    [t],
  );
}
